import templateUrl from './partnerTable.html';

angular.module('cfn').directive('cfnBookingPartner', function() {
  return {
    restrict: 'E',
    templateUrl,
    controller: [
      '$scope',
      function($scope) {
        $scope.items = [];

        $scope.add = function(item) {
          $scope.items.push(item);
        };

        $scope.goBackToCore = function(content, id) {
          $scope.$emit('goToCore', '/core/' + content + '/' + (id || ''));
        };

        // Remove item from items-Array
        $scope.remove = function(item) {
          for (var i = $scope.items.length - 1; i >= 0; i--) {
            if ($scope.items[i] == item) {
              $scope.items.splice(i, 1);
            }
          }
        };

        // Fill Client-Array "$scope.items"
        $scope.prepareLoad = function(section, details) {
          $scope.items = [];
          angular.forEach(details.resources, function(value) {
            var clientItem = {
              number: value.resource.number,
              combinedName: value.resource.combinedName,
              category: value.resource.category,
              id: value.resource.id
            };
            $scope.items.push(clientItem);
          });
        };

        // Fill Server-Array "details"
        $scope.prepareSave = function(section, details) {
          $scope.items.forEach(function(value) {
            var serverItem = {
              resource: {
                // For Backend
                id: value.id,
                objectsType: 'Person',
                // For goBackToCore
                number: value.number,
                combinedName: value.combinedName,
                category: value.category
              },
              resourceType: 'Person'
            };
            details.resources.push(serverItem);
          });
        };

        $scope.onClear = function() {
          $scope.items = [];
        };
      }
    ]
  };
});
